import { width } from "@mui/system";
import React, { useEffect, useState } from "react";
import apiClient from "../../api/apiClient";
import useApi from "../../hooks/useApi";

export default () => {
  const [Loading, setLoading] = useState("");
  const [newreq, setnewreq] = useState("");

  const fetch = async () => {
    setLoading(true);
    const response = await apiClient.get("/campaign/campaigns/");
    setLoading(false);

    if (!response.ok) return console.log("error");
    if (response.ok) {
      const data = response.data;
      setnewreq(response?.data);
    }
  };

  useEffect(() => {
    fetch();
  }, []);

  const { request, loading, error } = useApi((resultData) =>
    apiClient.post("/vehicleRequest", resultData)
  );
  return (
    <div>
      <div className="site-content h-100">
        <div className="p-4">
          <div className="site-content-body">
            <div className="container-fluid main_bg_color">
              <div className="row">
                <div className="col-md-6 px-md-2">
                  <div className="bg_more_deatils p-3 ">
                    <div className=" slider_line_height ">
                      <div className="d-flex message_dot_Posetion">
                        <span className="bottom_line mb-3">
                          <h5 className>New Campaign request</h5>
                        </span>
                      </div>
                      <p className="text-mute">
                        <span className="fw-bold">
                          Advertiser (type of business):
                        </span>
                        lawyer
                      </p>
                      <p>
                        <span className="fw-bold">Estimated Duration:</span> 6
                        Months
                      </p>
                      <p>
                        <span className="fw-bold">Anticipated Start Date:</span>
                        11/30/2022
                      </p>
                      <p>
                        <span className="fw-bold">Install Before:</span>
                        11/27/2022
                      </p>
                      <p>
                        <span className="fw-bold">Coverage Area:</span> Miami,
                        Fl
                      </p>
                      <p>
                        <span className="fw-bold">Radius:</span> Miami, Fl
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 px-md-2 mt-md-0 mt-2 ">
                  <div className=" bg_more_deatils  p-3">
                    <span className="bottom_line mb-3">
                      <h5 className>Requirements</h5>
                    </span>
                    <p>
                      <span className="fw-bold"> Perform 1 Swarm:</span> FTX
                      Arena
                    </p>
                    <p>
                      <span className="fw-bold"> Perform 1 Photoshoot:</span>
                      FTX Arena
                    </p>
                    <p>
                      <span className="fw-bold">Monthly Pictures:</span>
                      12/mth(+$75 bonus)
                    </p>
                    <p>
                      <span className="fw-bold">Attend Special Event:</span>
                      Miami, Heat NBA game
                    </p>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className=" col-md-6 px-md-2 my-2">
                  <div className="test-2 p-3" style={{ height: "260px" }}>
                    <div className="d-flex message_dot_Posetion">
                      <span className="bottom_line mb-3">
                        <h5 className>Advertiser's Design</h5>
                      </span>
                    </div>
                    <div className="d-flex justify-content-center">
                      <div style={{ width: "18rem" }}>
                        <div
                          id="carouselExampleControls"
                          class="carousel slide"
                          data-bs-ride="carousel"
                        >
                          <div class="carousel-inner">
                            <div class="carousel-item active">
                              <img
                                width={"100%"}
                                src={require("../../assets/img/new campaign.PNG")}
                                alt=""
                              />
                            </div>
                            <div class="carousel-item">
                              <img
                                width={"100%"}
                                src={require("../../assets/img/new campaign.PNG")}
                                alt=""
                              />
                            </div>
                            <div class="carousel-item">
                              <img
                                width={"100%"}
                                src={require("../../assets/img/new campaign.PNG")}
                                alt=""
                              />
                            </div>
                          </div>
                          <button
                            class="carousel-control-prev"
                            type="button"
                            data-bs-target="#carouselExampleControls"
                            data-bs-slide="prev"
                          >
                            <span
                              class="carousel-control-prev-icon"
                              aria-hidden="true"
                            ></span>
                            <span class="visually-hidden">Previous</span>
                          </button>
                          <button
                            class="carousel-control-next"
                            type="button"
                            data-bs-target="#carouselExampleControls"
                            data-bs-slide="next"
                          >
                            <span
                              class="carousel-control-next-icon"
                              aria-hidden="true"
                            ></span>
                            <span class="visually-hidden">Next</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=" col-md-6 mt-2">
                  <div className="test-2 p-3">
                    <div className="d-flex message_dot_Posetion">
                      <span className="bottom_line mb-3">
                        <h5 className>Total Estimated Earnings</h5>
                      </span>
                    </div>
                    <div className="d-flex justify-content-between px-3">
                      <p>Pay Per Months</p>
                      <p>$250.00/mth</p>
                    </div>
                    <div className="d-flex justify-content-between px-3">
                      <p>Duration (in months):</p>
                      <p>x 8 months</p>
                    </div>
                    <div className="d-flex justify-content-end mb-2">
                      <hr className="m-0" style={{ width: "30%" }} />
                    </div>
                    <div className="d-flex justify-content-between px-3">
                      <p>Total(without bonus):</p>
                      <p>$20000.00</p>
                    </div>
                    <div className="d-flex justify-content-between px-3">
                      <p>Monthly Photo Bonus:</p>
                      <p>+ $75.00</p>
                    </div>
                    <div className="d-flex justify-content-end mb-2">
                      <hr className="m-0" style={{ width: "30%" }} />
                    </div>

                    <div className="d-flex justify-content-between px-3">
                      <p>Total Estimated Earnings:</p>
                      <p className="fw-bold text_color">$2,075.00</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="d-flex justify-content-center p-2 ">
            <input type="checkbox" name="" id="terms" />
            <label className="ps-2" htmlFor="terms">
              Accept <span className="text_color">Terms & Conditions</span>
            </label>
          </div>
          <div className="d-flex justify-content-center ">
            <button className="btn btn_bg">Accept Campaign</button>
          </div>
        </div>
      </div>
    </div>
  );
};
